import React from 'react';

const SearchInput = ({ initialValue = "", onSearchChange, placeholder = "Rechercher..." }) => {
    const [inputValue, setInputValue] = React.useState(initialValue);

    // Debounced search effect
    React.useEffect(() => {
        const timeoutId = setTimeout(() => {
            onSearchChange(inputValue);
        }, 250);

        return () => clearTimeout(timeoutId);
    }, [inputValue, onSearchChange]);

    // Update internal state if initial value changes (e.g., from URL params)
    React.useEffect(() => {
        setInputValue(initialValue);
    }, [initialValue]);

    return (
        <div className={"col-md-4 col-8"}>
            <input
                type="text"
                className="form-control"
                placeholder={placeholder}
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
            />
        </div>
    );
};

export default SearchInput; 